export default __webpack_public_path__ + "static/media/alert-bg.b85b6724.png";